import styles from "./NormalButton.module.css";

function NormalButton({ leftIcon, text, onClick, className, disabled }) {
  return (
    <button className={` ${className} ${styles.button} ${disabled ? styles.disabled : ""}`} onClick={onClick}>
      {leftIcon && leftIcon}
      <span
        style={{
          paddingLeft: `${leftIcon ? "4px" : ""}`,
        }}
      >
        {text}
      </span>
    </button>
  );
}

export default NormalButton;
